/**
 * React Query mutations for LocatesV2 widget operations.
 */
import { createLocatesOrder } from './http/locates-ws/orders';
import type { CreateLocatesOrderParams } from './http/locates-ws/orders';
import { injectLocates } from './http/locates-ws/platforms/inject';
import type { MutationOptions } from '@tanstack/query-core';
import type { LocateOrder } from '@thinkalpha/ui-types/contracts/locates/orders';
import type { InjectLocatesParams } from 'src/queries/locatesV2/injection';

// Re-export the HTTP function for use in models
export { createLocatesOrder };
export type { CreateLocatesOrderParams };

/**
 * Mutation for creating a new locate order.
 * Returns the created orders (can be multiple for compound providers).
 */
export const createLocatesOrderMutation = (): MutationOptions<LocateOrder[], Error, CreateLocatesOrderParams> => {
    return {
        mutationFn: createLocatesOrder,
    };
};

export const injectLocatesMutation = (
    mutationFn: (params: InjectLocatesParams) => Promise<LocateOrder[]> = injectLocates,
): MutationOptions<LocateOrder[], Error, InjectLocatesParams> => ({ mutationFn });
